import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import ConfigContext from '../../contexts/ConfigContext';
import { footerStopsFor } from '../../modules/popularStops';

// Components
import FooterMailingList from './FooterMailingList';

import styles from './Footer.module.postcss';

function FooterListItem({ title, url }) {
  return (
    <div className={styles.Footer_listItem}>
      <Link to={url}>
        {title}
      </Link>
    </div>
  );
}

function Footer() {
  const { logo, site_title, facebook, instagram, twitter, vehicle_type, city_name } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const currentYear = new Date().getFullYear();
  const logoImg = (
    <img src={logo} alt={site_title} width='180' height='30' />
  );

  return (
    <footer className={styles.Footer}>
      <div className='Section--extraPadding'>
        <div className='u-flex'>
          <Link to='/'>
            {logoImg}
          </Link>
        </div>

        <div className={styles.Footer_listWrapper}>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Explore</h3>
            <FooterListItem title='Add your business' url='/vendors' />
            <FooterListItem title={`Book a food ${vehicleType}`} url='/catering' />
            <FooterListItem title={`Hire a food ${vehicleType}`} url='/hire-a-food-truck' />
            <FooterListItem title={`Food ${vehicleType} rental`} url='/food-truck-rental' />
            <FooterListItem title='Catering prices' url='/food-truck-catering/prices' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Community</h3>
            <FooterListItem title='About' url='/about' />
            <FooterListItem title='Blog' url='/blog' />
            <FooterListItem title='Support' url='/support' />
            <FooterListItem title='Terms & conditions' url='/terms-and-conditions' />
            <FooterListItem title='Privacy policy' url='/privacy-policy' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Event services</h3>
            <FooterListItem title='Corporate catering' url='/food-truck-catering/corporate-catering' />
            <FooterListItem title='Wedding catering' url='/food-truck-catering/wedding-catering' />
            <FooterListItem title='Private parties' url='/food-truck-catering/private-parties' />
            <FooterListItem title='Events & festivals' url='/food-truck-catering/community-events' />
            <FooterListItem title='Event catering' url='/food-truck-catering/events' />
            <FooterListItem title='Fundraisers' url='/food-truck-catering/fundraiser' />
            <FooterListItem title='Special occasions' url='/food-truck-catering/special-occasions' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Catering services</h3>
            <FooterListItem title={`Taco ${vehicleType} catering`} url='/food-truck-catering/taco-catering' />
            <FooterListItem title={`BBQ ${vehicleType} catering`} url='/food-truck-catering/bbq-catering' />
            <FooterListItem title={`Pizza ${vehicleType} catering`} url='/food-truck-catering/pizza-catering' />
            <FooterListItem title={`Asian ${vehicleType} catering`} url='/food-truck-catering/asian-catering' />
            <FooterListItem title={`Burger ${vehicleType} catering`} url='/food-truck-catering/burger-catering' />
            <FooterListItem title={`Dessert ${vehicleType} catering`} url='/food-truck-catering/dessert-catering' />
            <FooterListItem title={`Breakfast ${vehicleType} catering`} url='/food-truck-catering/breakfast-catering' />
          </div>
          <div className={styles.Footer_list}>
            <h3 className='u-phosphate u-mb1'>Popular locations</h3>
            {footerStopsFor(city_name).map((stop) => (
              <FooterListItem key={stop.link} title={stop.name} url={stop.link} />
            ))}
            <FooterListItem title='All locations' url='/explore' />
          </div>
        </div>
      </div>
      <div className={styles.Footer_wrapper + ' Section'}>
        <div className={styles.Footer_section}>
          {/* Bottom row and credit: owner decision 4 Sep 2026 (bible v4.2 §3
              exception) — the "Powered by Curbside Provisions" credit stays.
              The row ends with the mailing-list box. It left with Mailchimp
              (task #313) and is back saving addresses in our own database:
              owner decisions 6 Oct 2026 (task #330). */}
          <nav aria-label='Footer'>
            <Link to='/support' className={styles.Footer_navLink}>Support</Link>
            <Link to='/blog' className={styles.Footer_navLink}>Blog</Link>
            <Link to='/privacy-policy' className={styles.Footer_navLink}>Privacy policy</Link>
            <Link to='/terms-and-conditions' className={styles.Footer_navLink}>Terms of service</Link>
          </nav>

          <div className={styles.Footer_finePrint}>
            <p>
              Powered by <a href='http://www.curbsideprovisions.com'>Curbside Provisions</a>&nbsp;
              <span>&copy; {currentYear} All rights reserved</span>
            </p>
          </div>
        </div>

        <div className={styles.Footer_section}>
          <p className={styles.Footer_heading}>Follow us on social media</p>
          <div className={styles.Footer_social}>
            <a href={facebook}>
              <img src='/static/images/icons/footer/facebook.svg' alt='Facebook' width='30' height='30' />
            </a>
            <a href={'https://www.instagram.com/' + instagram}>
              <img src='/static/images/icons/footer/instagram.svg' alt='Instagram' width='30' height='30' />
            </a>
            <a href={'https://twitter.com/' + twitter}>
              <img src='/static/images/icons/footer/twitter.svg' alt='Twitter' width='30' height='30' />
            </a>
          </div>
        </div>

        <div className={styles.Footer_section}>
          <FooterMailingList />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
